import { Alert, DialogContent, Typography } from "@mui/material";

interface SubmissionContentProps {
  ticket: string;
}

const SubmissionContent = ({ ticket }: SubmissionContentProps) => {
  return (
    <DialogContent>
      <Alert severity="success">
        <Typography variant="body1">
          Your request has been received. Your ticket number is{" "}
          <strong>{ticket}</strong>.
        </Typography>
        <Typography>A confirmation email has been sent.</Typography>
      </Alert>
    </DialogContent>
  );
};

export default SubmissionContent;
